module.exports = __webpack_public_path__ + "img/chipin+-locked-light.70c157ec.svg";